import React from 'react';
import './HeroSection.css';
import {
  FaHome,
  FaRulerCombined,
  FaPencilRuler,
  FaBuilding,
  FaCouch,
  FaCompass,
} from 'react-icons/fa';

const HeroSection = () => {
  const cardData = [
    {
      icon: <FaHome size={60} color="#2e42a3" />,
      title: 'House Design in Minutes',
      description:
        'Unlock thousands of expert house plans instantly. Find your dream home tailored to your unique taste within 60 seconds.',
    },
    {
      icon: <FaRulerCombined size={60} color="#2e42a3" />,
      title: 'Floor Plan',
      description:
        'Expert floor plans make your dream home real. Perfect space utilization, less stress, and clear plans for easy building.',
    },
    {
      icon: <FaPencilRuler size={60} color="#2e42a3" />,
      title: 'Customized House Design',
      description:
        'Craft a unique home tailored to your lifestyle. Personalized design maximizing comfort, functionality, and lasting value. From concept to your bespoke home.',
    },
    {
      icon: <FaBuilding size={60} color="#2e42a3" />,
      title: 'House Elevation Design',
      description:
        'Elevate your home\'s curb appeal with stunning designs reflecting your style. See your home\'s beauty from every angle. Crafting a facade you\'ll love.',
    },
    {
      icon: <FaCouch size={60} color="#2e42a3" />,
      title: 'Interior Designing',
      description:
        'Transform your space and life with harmonious, comfortable designs reflecting your style. Beautiful and functional interiors tailored to your needs.',
    },
    {
      icon: <FaCompass size={60} color="#2e42a3" />,
      title: 'Vastu Consultancy',
      description:
        'Harmonize your space and enhance life with expert Vastu guidance. Create a balanced environment promoting peace and success.',
    },
  ];

  return (
    <div>
      <div className="content-main">
        <h1>Your Vision, Our Expertise</h1>
        <div className="card-section">
          {cardData.map((card, index) => (
            <div className="card" key={index}>
              <div className="card-icon">{card.icon}</div>
              <h3 className="card-header">{card.title}</h3>
              <p className="card-paragraph">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;